"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ModalFooter = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var button_1 = require("@kaizen/button");
var responsive_1 = require("@kaizen/responsive");
var GenericModalSection_1 = __importDefault(require("./GenericModalSection"));
var ModalFooter_module_scss_1 = __importDefault(require("./ModalFooter.module.scss"));
var ModalFooter = function (props) {
    var unpadded = props.unpadded, actions = props.actions, _a = props.appearance, appearance = _a === void 0 ? "primary" : _a, automationId = props.automationId, variant = props.variant;
    var queries = (0, responsive_1.useMediaQueries)().queries;
    return (react_1["default"].createElement(GenericModalSection_1["default"], { inputEdit: variant === "inputEdit" },
        react_1["default"].createElement("div", { className: (0, classnames_1["default"])(ModalFooter_module_scss_1["default"].actions, !unpadded && ModalFooter_module_scss_1["default"].padded, variant === "context" && ModalFooter_module_scss_1["default"].informationPadded, props.alignStart && ModalFooter_module_scss_1["default"].actionsAlignStart) }, actions.map(function (action, index) { return (react_1["default"].createElement("div", { className: ModalFooter_module_scss_1["default"].actionButton, key: index },
            react_1["default"].createElement(button_1.Button, __assign({ type: "button", primary: index === 0 && appearance === "primary", destructive: index === 0 && appearance === "destructive", secondary: index > 0, "data-automation-id": "".concat(automationId, "-action-").concat(index), "data-testid": "".concat(automationId, "-action-").concat(index), fullWidth: queries.isSmall }, action)))); }))));
};
exports.ModalFooter = ModalFooter;
exports.ModalFooter.displayName = "ModalFooter";
//# sourceMappingURL=ModalFooter.js.map